import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import ConfirmDialog from 'chameleon/ui-stack/ui/modals/confirm-dialog';

const UnableToViewModal = (props) => {
  const { onClose, title, description, otherDescription } = props;

  return (
    <ConfirmDialog
      title={title}
      onSuccess={onClose}
      onClose={onClose}
      content={{
        btnPrimary: 'Ok',
      }}
    >
      <p>{description}</p>
      {otherDescription !== null ? (
        otherDescription
      ) : (
        <Fragment>
          <p>From this menu, students can click: </p>
          <ul>
            <li>
              <strong>My AP</strong> to join classes and view AP exam
              information.
            </li>
            <li>
              <strong>My Account</strong> to view and update personal
              information.
            </li>
          </ul>
        </Fragment>
      )}
    </ConfirmDialog>
  );
};

UnableToViewModal.propTypes = {
  onClose: PropTypes.func,
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  description: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
    .isRequired,
  otherDescription: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
};

UnableToViewModal.defaultProps = {
  onClose: () => {},
  title: 'About the AP Classroom Student View',
  description:
    'The Student View is only able to share what students see in AP Classroom.',
  otherDescription: null,
};

export default UnableToViewModal;
